var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCharmMenuMeatballNew(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.03125 7.10938C2.3678 7.10938 2.64062 6.83655 2.64062 6.5C2.64062 6.16345 2.3678 5.89062 2.03125 5.89062C1.6947 5.89062 1.42188 6.16345 1.42188 6.5C1.42188 6.83655 1.6947 7.10938 2.03125 7.10938Z",
    stroke: "black",
    strokeWidth: 1.21875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 7.10938C6.83655 7.10938 7.10938 6.83655 7.10938 6.5C7.10938 6.16345 6.83655 5.89062 6.5 5.89062C6.16345 5.89062 5.89062 6.16345 5.89062 6.5C5.89062 6.83655 6.16345 7.10938 6.5 7.10938Z",
    stroke: "black",
    strokeWidth: 1.21875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9688 7.10938C11.3053 7.10938 11.5781 6.83655 11.5781 6.5C11.5781 6.16345 11.3053 5.89062 10.9688 5.89062C10.6322 5.89062 10.3594 6.16345 10.3594 6.5C10.3594 6.83655 10.6322 7.10938 10.9688 7.10938Z",
    stroke: "black",
    strokeWidth: 1.21875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCharmMenuMeatballNew);
export default __webpack_public_path__ + "static/media/charm_menu-meatball-new.212afe24e17a7a61f30701938d6faa7a.svg";
export { ForwardRef as ReactComponent };